import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { IReportDateRangePicker, ISignature, ReportStatus } from '@shared/interfaces';
import { ReportBuilderService } from '../../services/report-builder.service';
import { DialogService } from '../../../../shared/services/dialog.service';
import { Subscription } from 'rxjs';
import { ReportGetter } from '../../directives/ReportGetter';
import { MatDialog } from '@angular/material/dialog';
import { ReportSignatureUploadComponent } from '../report-signature-upload/report-signature-upload.component';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { GuardService } from '@shared/services';
import { ModuleService } from '../../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-report-main-info',
    templateUrl: './report-main-info.component.html',
    styleUrls: ['./report-main-info.component.scss'],
    standalone: false
})
export class ReportMainInfoComponent extends ReportGetter implements OnInit, AfterViewInit {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    @Output() signature = new EventEmitter<string>();
    subscription: Subscription;
    @ViewChild('rightContainer') rightContainer: ElementRef;
    @ViewChild('leftContainer') leftContainer: ElementRef;
    @ViewChild('executiveSignature') executiveSignature: ElementRef;

    private _execSignatureHeight;
    protected dateRangePickerFormGroup: FormGroup<IReportDateRangePicker>;

    constructor(
        private dialogService: DialogService,
        private changeRef: ChangeDetectorRef,
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
    }

    private _radius: number;

    get radius(): number {
        return this._radius;
    }

    ngOnInit(): void {
        this.dateRangePickerFormGroup = new FormGroup({
            reportStartDate: new FormControl(
                { value: new Date(this.reportStartDate), disabled: true },
                Validators.required
            ),
            reportEndDate: new FormControl({ value: new Date(this.reportEndDate), disabled: true }, Validators.required)
        });
    }

    ngAfterViewInit() {
        this.leftContainer.nativeElement.style.minHeight = this.rightContainer.nativeElement.clientHeight - 50 + 'px';
        this._radius = this.leftContainer?.nativeElement?.clientHeight / 2 - 50;
        this.changeRef.detectChanges();
    }

    get responsibleCanSign(): boolean {
        if (IS_TRS_PROJECT) {
            return !(
                !this.isAbleToSignAsSpecialist ||
                this.isReleased ||
                !this.isReadyToSign ||
                this.responsibleSignature ||
                (this.specialistSignature as ISignature[])?.length !== this.specialistSigners.length
            );
        }

        if (IS_PRODUCT_SAFETY_PROJECT) {
            return !(
                !this.isAbleToSignAsSpecialist ||
                this.isReleased ||
                !this.isReadyToSign ||
                this.responsibleSignature ||
                !this.specialistSignature
            );
        }
    }

    get specialistCanSign(): boolean {
        if (IS_TRS_PROJECT) {
            return !(
                !this.isAbleToSignAsSpecialist ||
                this.isReleased ||
                !this.isReadyToSign ||
                !!this.signatureForSigner(this.guard.currentUser.id)
            );
        }
        if (IS_PRODUCT_SAFETY_PROJECT) {
            return !(
                !this.isAbleToSignAsSpecialist ||
                this.isReleased ||
                !this.isReadyToSign ||
                this.specialistSignature
            );
        }
    }

    public signAsSpecialist() {
        const project = IS_TRS_PROJECT
            ? this.translateService.instant('project.trs.name')
            : this.translateService.instant('project.product-safety.name');
        const projectAbbreviation = IS_TRS_PROJECT
            ? this.translateService.instant('project.trs.abbreviation')
            : this.translateService.instant('project.product-safety.abbreviation');
        const title = this.translateService.instant('report-main-info.title-specialist');
        const message = this.translateService.instant('report-main-info.description-specialist', {
            project,
            projectAbbreviation
        });
        this.dialogService.openDialog({ title, message }).subscribe(result => {
            if (result?.result) {
                if (IS_PRODUCT_SAFETY_PROJECT) {
                    this.report.specialistSignature = {};
                }
                // this.report.notifyResponsible = checked;
                this.report.notifyResponsible = false;
                this.builder.calculateDoc();
                if (this.report.responsibleSignature) {
                    this.report.reportStatus = ReportStatus.released;
                }
                this.signature.emit('specialist');
            }
        });
    }

    signForResponsible() {
        this.dialog
            .open(ReportSignatureUploadComponent, {
                position: { top: '50px' },
                width: '900px',
                panelClass: 'custom-dialog'
            })
            .beforeClosed()
            .subscribe(result => {
                if (result) {
                    this.report.responsibleSignature = {};
                    this.builder.calculateDoc();
                    this.report.reportStatus = ReportStatus.released;
                    this.signature.emit('responsible');
                }
            });
    }

    protected singleSignatureResult(signature: ISignature | ISignature[]): ISignature {
        return signature as ISignature;
    }

    protected dateRangePickerChanged(): void {
        this.reportStartDate = this.dateRangePickerFormGroup.controls.reportStartDate.value;
        this.reportEndDate = this.dateRangePickerFormGroup.controls.reportEndDate.value;
    }
}
